import { render, staticRenderFns } from "./ModalPEAKMobile.vue?vue&type=template&id=40898648&scoped=true"
import script from "./ModalPEAKMobile.vue?vue&type=script&lang=ts"
export * from "./ModalPEAKMobile.vue?vue&type=script&lang=ts"
import style0 from "./ModalPEAKMobile.vue?vue&type=style&index=0&id=40898648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40898648",
  null
  
)

export default component.exports